import { render, staticRenderFns } from "./ViewableItem.vue?vue&type=template&id=64dd3208&scoped=true"
import script from "./ViewableItem.vue?vue&type=script&lang=ts"
export * from "./ViewableItem.vue?vue&type=script&lang=ts"
import style0 from "./ViewableItem.vue?vue&type=style&index=0&id=64dd3208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd3208",
  null
  
)

export default component.exports